import { useQuery } from '@tanstack/react-query'

import { getUserMe } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchUserMe = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled,
    queryFn: () => getUserMe(axiosInstance),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_USER_ME],
  })
}
